module.exports = __webpack_public_path__ + "static/divas8-bb668db87481567480b4d9de115b9ae5.jpg";